module.exports = __webpack_public_path__ + "media/playing_two_line_5.37d492f8.mp3";